import { NavigationItemType } from 'framework/navigation';

const normalizePath = (path: string) => (path !== '/' && path.endsWith('/') ? path.slice(0, -1) : path);

const pathMatches = (url: string | undefined, pathname: string, exact = false): boolean => {
  if (!url || !pathname) return false;
  const normalizedUrl = normalizePath(url);
  const normalizedPath = normalizePath(pathname);
  return normalizedPath === normalizedUrl || (!exact && normalizedPath.startsWith(`${normalizedUrl}/`));
};

const hasDescendantMatch = (item: NavigationItemType, pathname: string): boolean =>
  !!item.children?.some(
    child => pathMatches(child.url, pathname, !!child.exact) || hasDescendantMatch(child, pathname),
  );

export const isHeaderMenuItemActive = (item: NavigationItemType, pathname: string): boolean =>
  pathMatches(item.url, pathname, !!item.exact) ||
  hasDescendantMatch(item, pathname) ||
  !!item.includeUrls?.some(url => pathMatches(url, pathname));
